import { Injectable } from '@angular/core';
import { ICommunicationEvent } from '../ICommunicationEvent';
import { PlatformCommunicationEvents } from '@shared/generalInterfaces';
import { ClientDiscoveryService } from '../../../platform/services/client-discovery/client-discovery.service';

@Injectable({ providedIn: 'root' })
export class GetAppsConfigEvent implements ICommunicationEvent {
	constructor(private readonly clientDiscoveryService: ClientDiscoveryService) {}

	get eventName(): string {
		return PlatformCommunicationEvents.GetApplicationsConfiguration;
	}

	async handleEvent(event: any, publishEventFunc: Function) {
		const appIds = event.data.appIds;
		const appsConfig = await this.clientDiscoveryService.getClientApplications(appIds);

		await publishEventFunc(PlatformCommunicationEvents.ApplicationsConfigurationResult, [event.eventHeader.publisher], appsConfig);
	}
}
